const FRT_PARAMETERS_KEY =  "frt_parameters"
export const setStoredFRTParameters = (frtParameters: Map<string,string>) => {
    const jsonText = JSON.stringify(Array.from(frtParameters.entries()))
    sessionStorage.setItem(FRT_PARAMETERS_KEY, jsonText)
}
export const getStoredFRTParameters = ():Map<string, string>|undefined => {
    const params = sessionStorage.getItem(FRT_PARAMETERS_KEY)
    return params ? new Map(JSON.parse(params)) : undefined
}
